import { render, staticRenderFns } from "./ConfigurationZoneMobile.vue?vue&type=template&id=1c54fcea&scoped=true&"
import script from "./ConfigurationZoneMobile.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationZoneMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationZoneMobile.vue?vue&type=style&index=0&id=1c54fcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54fcea",
  null
  
)

export default component.exports